import Cookies from '../services/cookies';

const module = {
    checkBreadcrumbsVisibility(requestData) {
        const $breadCrumbs = $('.js_breadcrumbs');
        const $mainBanner = $('.js_main-banner');
        const breadCrumbsNumber = $breadCrumbs.find('li').length;
        const isSearchParamPresent = requestData?.searchParams.q;

        if ((breadCrumbsNumber < 3) || isSearchParamPresent) {
            $mainBanner.addClass('mark-banner');
            $('.js_banner-vendor').addClass('mark-banner');
            $breadCrumbs.removeClass('m_mobile-hidden').addClass('m_mobile-hidden');
        } else {
            $breadCrumbs.removeClass('m_mobile-hidden');
        }
    },
    getUrlParams() {
        return new Proxy(new URLSearchParams(window.location.search), {
            get: (searchParams, prop) => searchParams.get(prop),
        });
    },
    setCookie(cname, cvalue, exdays) {
        let cookies = new Cookies();
        cookies.setCookie(cname, cvalue, exdays);
    },

    getCookie(cname) {
        let cookies = new Cookies();
        return cookies.getCookie(cname);
    },
    scrollTop: () => {
        $('html, body').scrollTop(0);
    },
};

export default module;
